export default "__VITE_ASSET__CLGhnjss__"